﻿(function () {
  var sidebar = document.getElementById('pltm-sidebar');
  var overlay = document.getElementById('pltm-sidebar-overlay');
  var toggle = document.getElementById('pltm-sidebar-toggle');
  var closeBtn = document.getElementById('pltm-sidebar-close');

  if (!sidebar) return;

  function open() {
    sidebar.classList.add('is-open');
    overlay.classList.add('is-visible');
    sidebar.setAttribute('aria-hidden', 'false');
    toggle.innerHTML = '&#215;';
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.style.display = 'block';
  }

  function close() {
    sidebar.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    sidebar.setAttribute('aria-hidden', 'true');
    toggle.innerHTML = '+';
    document.body.style.overflow = '';
    if (closeBtn) closeBtn.style.display = 'none';
  }

  toggle.addEventListener('click', function () {
    sidebar.classList.contains('is-open') ? close() : open();
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Nested nav items (e.g. "SHOP ALL") start collapsed — the chevron button toggles the
  // sub-links open/closed, separately from the link text, which navigates normally. Accordion
  // behavior: opening one group closes any other that's currently open.
  var navGroups = sidebar.querySelectorAll('.pltm-sidebar__nav-group');
  for (var i = 0; i < navGroups.length; i++) {
    var group = navGroups[i];
    var chevronBtn = group.querySelector('.pltm-sidebar__chevron-btn');
    if (!chevronBtn) continue;
    chevronBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var thisGroup = this.closest('.pltm-sidebar__nav-group');
      var wasOpen = thisGroup.classList.contains('is-open');
      for (var j = 0; j < navGroups.length; j++) {
        navGroups[j].classList.remove('is-open');
        var otherSub = navGroups[j].querySelector('.pltm-sidebar__sub-links');
        if (otherSub) otherSub.style.maxHeight = '0px';
      }
      if (!wasOpen) {
        thisGroup.classList.add('is-open');
        var subLinks = thisGroup.querySelector('.pltm-sidebar__sub-links');
        if (subLinks) subLinks.style.maxHeight = subLinks.scrollHeight + 'px';
      }
    });
  }
})();

